"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bundlePricingMoneyMapping = void 0;
exports.bundlePricingMoneyMapping = {
    cost: "costScaled",
    price: "priceScaled",
    priceWithVAT: "priceWithVATScaled",
    priceV2: "priceV2Scaled",
    rrp: "rrpScaled",
    rrpWithVAT: "rrpWithVATScaled",
    compareAtRetailPrice: "compareAtRetailPriceScaled",
    compareAtWholesalePrice: "compareAtWholesalePriceScaled",
};
